// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qf-c";
export var backButton = "_qf-4";
export var backIcon = "_qf-5";
export var chevronShortcut = "_qf-6";
export var container = "_qf-1";
export var editor = "_qf-8";
export var editorWrapper = "_qf-7";
export var prefix = "_qf-2";
export var searchIcon = "_qf-3";
export var suffix = "_qf-9";
export var suffixContent = "_qf-a";
export var suffixText = "_qf-b";
export var wrapper = "_qf-0";